import { Category } from '~/models/search/types'

export enum SuggestionType {
  FILTER = 'filter',
  AUTOCOMPLETE = 'autocomplete',
  LEGACY = 'legacy',
  CLASSIFIED = 'classified',
  MORE = 'more'
}

export interface SearchbarSuggestionData {
  url?: string
  suggester?: boolean
  category?: string
  query?: string
  phrase?: string
  path?: string[]
}

export interface SearchbarSuggestion {
  data: SearchbarSuggestionData
  displayPhrase?: string
  tags?: string[]
  id?: number
  uqtId?: number | string
  raw?: boolean
  fromHistory?: boolean
  lastSearch?: string
}

export type SmartSuggestionType =
  | 'autocomplete'
  | 'action'
  | 'classified'
  | 'insight'

export interface SmartResultSection {
  title?: string
  type: SmartSuggestionType
  suggestions: SmartAction[] | SmartAutocompletion[] | SmartClassified[]
  content?: SmartInsightContent
  fetching: boolean
  tags: string[]
}

export interface SmartSearchbarPlaceholdersResult {
  placeholders: string[]
}

export interface SmartAutocompletion {
  query: string
}

export interface SmartAutocompleteResult {
  tags: string[]
  completions: SmartAutocompletion[]
  title: string
}

export interface SmartAction {
  url: string
  tags: string[]
  title: string
}

export interface SmartActionResult {
  tags: string[]
  actions: SmartAction[]
  title: string
}

export interface SmartClassified {
  url: string
  image?: string | null
  subtitle?: string | null
  price: string
  title: string
}

export interface SmartClassifiedResult {
  tags: string[]
  classifieds: SmartClassified[]
  title: string
}

export interface SmartInsightContent {
  response: string
  contextItems: string[]
}

export interface SmartInsightResult {
  tags: string[]
  content: SmartInsightContent
  title: string
}

export interface SearchbarLegacySuggestion {
  category: Category
  categoryHumanPathParts: any[]
  count: number
  isFuzzy: boolean
  isUNderSameRoot: boolean
  name: string
  popularity: number
  seoUrl: string
  tags?: string[]
  value: LegacySuggestionValue
}

export interface LegacySuggestionValue {
  category: string | number
  q: string
}
